import React, {Component} from 'react';
import Page from '../../components/Page';
import {getHolidays, updateHoliday, createHoliday, deleteHoliday} from '../../actions/holidays';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Modal from 'react-responsive-modal';
import './styles.css';


const DEFAULT_STATE = {
    open: false,
    action: '',
    _id: '',
    name: '',
    day: 0,
    month: 0,
    year: 0,

};

class Holidays extends Component {

    constructor(props) {
        super(props);
        this.state = DEFAULT_STATE;
        this._onClickEdit = this._onClickEdit.bind(this);
        this._onClickRemove = this._onClickRemove.bind(this);
        this._onCloseModal = this._onCloseModal.bind(this);
        this._onChangeInput = this._onChangeInput.bind(this);
        this._onClickAction = this._onClickAction.bind(this);
        this._onClickCreate = this._onClickCreate.bind(this);
    }

    componentWillMount() {
        this.props.dispatch(getHolidays())
    }

    _onClickEdit(holiday) {
        let state = Object.assign({}, {open :true, action: 'Edit'}, _.omit(holiday, ['createdAt', 'updatedAt']));
        this.setState(state);
    }

    _onClickCreate() {
        let state = Object.assign({}, DEFAULT_STATE, {open :true, action: 'Create'});
        this.setState(state);
    }

    _onClickAction() {
        let omits = ['_id', 'open', 'action'];
        if (!this.state.year) {
            omits.push('year');
        }
        let data = _.omit(this.state, omits);

        if (this.state.action === 'Edit') {
            this.props.dispatch(updateHoliday((error, json)=> {
                if (!error) {
                    let state = Object.assign({}, DEFAULT_STATE);
                    this.setState(state);
                }
            }, this.state._id, data));
        } else if (this.state.action === 'Create') {
            this.props.dispatch(createHoliday((error, json)=> {
                if (!error) {
                    let state = Object.assign({}, DEFAULT_STATE);
                    this.setState(state);
                }
            }, data));
        }
    }

    _onClickRemove(id) {
        this.props.dispatch(deleteHoliday(()=> {}, id));
    }

    _onCloseModal() {
        let state = Object.assign({}, DEFAULT_STATE);
        this.setState(state);
    };

    _onChangeInput(property, event) {
        let state = Object.assign({}, this.state);
        state[property] = event.target.value;
        this.setState(state);
    }


    render() {
        const monthNames = ['—','January','February','March','April','May','June','July','August','September','October','November','December'];
        let holidays = [];

        this.props.holidays.forEach((holiday, index) => {
            holidays.push(<tr key={'holiday_' + index}>
                <td><span className="User-Cell"><i className="fa fa-star" style={{color: 'var(--accent-500)'}} /> {holiday.name}</span></td>
                <td className="tabular">{holiday.day}</td>
                <td>{monthNames[holiday.month] || holiday.month}</td>
                <td className="tabular">{holiday.year ? holiday.year : <span className="text-muted-2">Every year</span>}</td>
                <td>
                    <div className="Row-Actions">
                        <button onClick={()=> this._onClickEdit(holiday)} className="btn btn-default" title="Edit holiday">
                            <i className="fa fa-pencil" style={{color: 'var(--brand-700)'}} aria-hidden="true"></i>
                        </button>
                        <button onClick={()=> this._onClickRemove(holiday._id)} className="btn btn-default" title="Remove holiday">
                            <i className="fa fa-trash" style={{color: 'var(--danger)'}} aria-hidden="true"></i>
                        </button>
                    </div>
                </td>
            </tr>);

        });
        if (!holidays.length) {
            holidays.push(<tr key="holidays_empty"><td colSpan="5"><div className="Empty"><i className="fa fa-star-o" /><div className="t">No holidays yet</div></div></td></tr>);
        }

        return (
            <Page {...this.props} >

                <Modal open={this.state.open} onClose={this._onCloseModal} little>

                    <div className="Modal-Head"><h3>{this.state.action === 'Create' ? 'New holiday' : 'Edit holiday'}</h3></div>

                    <div className="Modal-Body">
                        <div className="Input-Group">
                            <label>Name</label>
                            <input type="text" className="form-control" placeholder="New Year’s Eve"
                                   value={this.state.name}
                                   onChange={event => this._onChangeInput('name', event)}
                            />
                        </div>

                        <div className="Field-Row">
                            <div className="Input-Group">
                                <label>Day</label>
                                <input type="number" className="form-control" placeholder="31"
                                       min="1" max="31"
                                       value={this.state.day}
                                       onChange={event => this._onChangeInput('day', event)}
                                />
                            </div>
                            <div className="Input-Group">
                                <label>Month</label>
                                <input type="number" className="form-control" placeholder="12"
                                       min="1" max="12"
                                       value={this.state.month}
                                       onChange={event => this._onChangeInput('month', event)}
                                />
                            </div>
                            <div className="Input-Group">
                                <label>Year</label>
                                <input type="number" className="form-control" placeholder="0 = every year"
                                       min="0" max="2100"
                                       value={this.state.year}
                                       onChange={event => this._onChangeInput('year', event)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="Modal-Foot">
                        <button type="button" className="btn btn-default" onClick={this._onCloseModal}>Cancel</button>
                        <button type="button" className="btn btn-primary" onClick={this._onClickAction}>
                            {this.state.action === 'Create' ? 'Create holiday' : 'Save changes'}
                        </button>
                    </div>

                </Modal>

                <div className="col-xs-12">
                    <div className="Plus-Icon" title="Create holiday" onClick={this._onClickCreate}>
                        <i className="fa fa-plus-circle" aria-hidden="true"></i>
                    </div>
                    <div className="Card" style={{padding: 0}}>
                        <div className="Table-Wrap" style={{border: 0}}>
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Day</th>
                                    <th scope="col">Month</th>
                                    <th scope="col">Year</th>
                                    <th scope="col">Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                {holidays}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </Page>
        );
    }
}

Holidays.propTypes = {
    holidays: PropTypes.arrayOf(PropTypes.object),
};

Holidays.defaultProps = {
    holidays: [],
};


function mapStateToProps(state) {
    const holidays = state.holidays;
    return {
        holidays: holidays,
    };
}

export default connect(mapStateToProps)(Holidays);



// WEBPACK FOOTER //
// ./src/screens/Holidays/index.js